import { render, staticRenderFns } from "./chat-info-section.html?vue&type=template&id=01ec88dd&scoped=true&external"
import script from "./chat-info-section.js?vue&type=script&lang=js&external"
export * from "./chat-info-section.js?vue&type=script&lang=js&external"
import style0 from "./chat-info-section.scss?vue&type=style&index=0&id=01ec88dd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec88dd",
  null
  
)

export default component.exports